'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var PropTypes = _interopDefault(require('prop-types'));
var React = require('react');
var React__default = _interopDefault(React);
var R = require('ramda');
var __chunk_1 = require('./_virtual/_rollupPluginBabelHelpers.js');
var __chunk_2 = require('./internal-helpers/index.js');

/**
 * Primitive to build a date select
 * @param {number} value Timestamp
 * @param {number} min Minimum date
 * @param {number} max Maximum date
 * @returns {ReactComponent}
 * @example
 * <DateSelect
 *  min={new Date('January 19, 2016')}
 *  max={new Date()}
 * >
 *  {data => (
 *    <Select
 *      label="Day"
 *      name="day"
 *      options={data.options.days}
 *      value={data.values.day}
 *      onChange={value => data.onChange('day', value)}
 *    />
 *    <Select
 *      label="Month"
 *      name="month"
 *      options={data.options.months}
 *      value={data.values.month}
 *      onChange={value => data.onChange('month', value)}
 *      />
 *    <Select
 *      label="Year"
 *      month="year"
 *      options={data.options.years}
 *      value={data.values.year}
 *      onChange={value => data.onChange('year', value)}
 *    />
 *  )}
 * </DateSelect>
 */

var DateSelect =
/*#__PURE__*/
function (_React$PureComponent) {
  __chunk_1.inherits(DateSelect, _React$PureComponent);

  function DateSelect() {
    var _this;

    __chunk_1.classCallCheck(this, DateSelect);

    _this = __chunk_1.possibleConstructorReturn(this, __chunk_1.getPrototypeOf(DateSelect).call(this));
    _this.getProps = _this.getProps.bind(__chunk_1.assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(__chunk_1.assertThisInitialized(_this));
    return _this;
  }

  __chunk_1.createClass(DateSelect, [{
    key: "getProps",
    value: function getProps() {
      var date = new Date(this.props.value);
      var min = new Date(this.props.min);
      var max = new Date(this.props.max);
      return {
        values: {
          day: date.getDate(),
          month: date.getMonth(),
          year: date.getFullYear()
        },
        options: {
          days: R.map(function (value) {
            return {
              label: value,
              value: value
            };
          }, __chunk_2.getDateRange(min, max, date)),
          months: R.map(function (value) {
            return {
              label: value + 1,
              value: value
            };
          }, __chunk_2.getMonthRange(min, max, date)),
          years: R.map(function (value) {
            return {
              label: value,
              value: value
            };
          }, __chunk_2.getYearRange(min, max))
        },
        onChange: this.handleChange
      };
    }
  }, {
    key: "handleChange",
    value: function handleChange(unit, value) {
      var nextDate = __chunk_2.getNextDate(unit, this.props.value, value);
      this.props.onChange(nextDate);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children(this.getProps());
    }
  }]);

  return DateSelect;
}(React__default.PureComponent);
DateSelect.propTypes = {
  children: PropTypes.func.isRequired,
  value: PropTypes.instanceOf(Date).isRequired,
  values: PropTypes.objectOf({
    day: PropTypes.number,
    month: PropTypes.number,
    year: PropTypes.number
  }),
  max: PropTypes.instanceOf(Date).isRequired,
  min: PropTypes.instanceOf(Date).isRequired,
  options: PropTypes.objectOf({
    days: PropTypes.arrayOf({
      label: PropTypes.number,
      value: PropTypes.number
    }),
    months: PropTypes.arrayOf({
      label: PropTypes.number,
      value: PropTypes.number
    }),
    years: PropTypes.arrayOf({
      label: PropTypes.number,
      value: PropTypes.number
    })
  }),
  onChange: PropTypes.func.isRequired
};

exports.DateSelect = DateSelect;
//# sourceMappingURL=date-select.js.map
